import { Link } from "wouter";
import { ArrowRight, Plane, Briefcase, Compass, MapPin, Building, Palmtree } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function TravelOptions() {
  const travelOptions = [
    {
      title: "Luxury Holidays to Turkey",
      description: "Indulge in 5-star experiences with premium accommodations, private tours, and exclusive beach access across Turkey's most prestigious destinations.",
      icon: <Building className="w-10 h-10 text-amber-500" />,
      link: "/destinations",
      color: "bg-amber-50",
    },
    {
      title: "Cheap Holidays to Turkey",
      description: "Discover affordable packages to Side, Turkey and other budget-friendly destinations without compromising on authentic experiences and beautiful beaches.",
      icon: <Briefcase className="w-10 h-10 text-emerald-500" />,
      link: "/practical-info",
      color: "bg-emerald-50",
    },
    {
      title: "Istanbul Vacation",
      description: "Explore the cultural tapestry of Istanbul where East meets West, with ancient palaces, vibrant markets, and unique Turkey holidays Istanbul experiences.",
      icon: <Compass className="w-10 h-10 text-blue-500" />,
      link: "/destinations",
      color: "bg-blue-50",
    },
    {
      title: "Holidays in Bodrum",
      description: "Enjoy the perfect blend of turquoise waters, historic sites, and vibrant nightlife while holidaying in Turkey's premier coastal paradise.",
      icon: <Palmtree className="w-10 h-10 text-cyan-500" />,
      link: "/destinations",
      color: "bg-cyan-50",
    },
    {
      title: "Turkey Travel Guide",
      description: "Essential information for planning your perfect Turkey travel itinerary, from visa requirements to cultural insights and local transportation tips.",
      icon: <MapPin className="w-10 h-10 text-red-500" />,
      link: "/practical-info",
      color: "bg-red-50",
    },
    {
      title: "Dalaman Travel Packages",
      description: "Discover the Turquoise Coast with tailor-made Dalaman travel packages including airport transfers, beach resorts, and boat tours to hidden coves.",
      icon: <Plane className="w-10 h-10 text-violet-500" />,
      link: "/transportation",
      color: "bg-violet-50",
    },
  ];

  return (
    <section className="py-16 bg-[#F8F9FA]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Plan Your Perfect Turkey Holiday</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From luxury holidays to Turkey's finest resorts to cheap holidays to Side, Turkey - discover the perfect travel option for your budget and preferences.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {travelOptions.map((option, index) => (
            <Card key={index} className={`overflow-hidden transition-all duration-300 hover:shadow-xl ${option.color} border-none`}>
              <CardHeader className="pb-2">
                <div className="mb-3">{option.icon}</div>
                <CardTitle className="text-xl font-bold">{option.title}</CardTitle>
                <CardDescription className="text-gray-700">{option.description}</CardDescription>
              </CardHeader>
              <CardContent>
                <Link href={option.link}>
                  <Button variant="outline" className="mt-2 w-full group transition-colors">
                    Explore Options
                    <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </Button>
                </Link>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link href="/faq">
            <Button className="bg-[#E30A17] hover:bg-[#c90915] text-white">
              View Our Travel FAQ
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
} 